module.exports = __webpack_public_path__ + "static/media/RoundedRect_Red@3x.30b40f0b.png";